// FistOS control protocol — server-driven tasks and the remote planner loop
// (AGENTS.md §6.3). The device runs no model: it assembles context into a
// PlanRequest, the server answers with a Decision, and the device executes
// the Decision through the policy broker.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_action } from "./action_pb.js";
import { file_approval } from "./approval_pb.js";
import { file_events } from "./events_pb.js";
import { file_observe } from "./observe_pb.js";
import { file_session } from "./session_pb.js";
/**
 * Describes the file task.proto.
 */
export const file_task = /*@__PURE__*/ fileDesc("Cgp0YXNrLnByb3RvEglmaXN0b3MudjEiVgoEVGFzaxIPCgd0YXNrX2lkGAEgASgJEgwKBGdvYWwYAiABKAkSLwoLY29uc3RyYWludHMYAyABKAsyGi5maXN0b3MudjEuVGFza0NvbnN0cmFpbnRzImwKD1Rhc2tDb25zdHJhaW50cxIRCgltYXhfc3RlcHMYASABKA0SEQoJdGltZW91dF9zGAIgASgNEhgKEGFsbG93ZWRfcGFja2FnZXMYAyADKAkSGQoRYWx3YXlzX3NjcmVlbnNob3QYBCABKAgiLQoKVGFza0NhbmNlbBIPCgd0YXNrX2lkGAEgASgJEg4KBnJlYXNvbhgCIAEoCSKYAwoJRGF0YUJsb2NrEhAKCGJsb2NrX2lkGAEgASgJEiUKBnNvdXJjZRgCIAEoDjIVLmZpc3Rvcy52MS5EYXRhU291cmNlEhQKDHBhY2thZ2VfbmFtZRgDIAEoCRIUCgx0aW1lc3RhbXBfbXMYBCABKAMSLAoHdWlfdHJlZRgKIAEoCzIZLmZpc3Rvcy52MS5VaVRyZWVTbmFwc2hvdEgAEisKCnNjcmVlbnNob3QYCyABKAsyFS5maXN0b3MudjEuU2NyZWVuc2hvdEgAEiIKA3NtcxgMIAEoCzITLmZpc3Rvcy52MS5TbXNFdmVudEgAEjQKDG5vdGlmaWNhdGlvbhgNIAEoCzIcLmZpc3Rvcy52MS5Ob3RpZmljYXRpb25FdmVudEgAEiQKBGNhbGwYDiABKAsyFC5maXN0b3MudjEuQ2FsbEV2ZW50SAASDgoEdGV4dBgPIAEoCUgAEjAKDWFjdGlvbl9vdXRwdXQYECABKAsyFy5maXN0b3MudjEuQWN0aW9uUmVzdWx0SABCCQoHY29udGVudCKTAQoLU3RlcFN1bW1hcnkSDAoEc3RlcBgBIAEoDRIhCgZhY3Rpb24YAiABKAsyES5maXN0b3MudjEuQWN0aW9uEicKBnN0YXR1cxgDIAEoDjIXLmZpc3Rvcy52MS5BY3Rpb25TdGF0dXMSKgoIYXBwcm92YWwYBCABKA4yGC5maXN0b3MudjEuQXBwcm92YWxDbGFzcyLnAQoLUGxhblJlcXVlc3QSDwoHdGFza19pZBgBIAEoCRIMCgRzdGVwGAIgASgNEgwKBGdvYWwYAyABKAkSLwoLY29uc3RyYWludHMYBCABKAsyGi5maXN0b3MudjEuVGFza0NvbnN0cmFpbnRzEi0KDGNhcGFiaWxpdGllcxgFIAEoCzIXLmZpc3Rvcy52MS5DYXBhYmlsaXRpZXMSJwoHaGlzdG9yeRgGIAMoCzIWLmZpc3Rvcy52MS5TdGVwU3VtbWFyeRIiCgRkYXRhGAcgAygLMhQuZmlzdG9zLnYxLkRhdGFCbG9jayIqCgZGaW5pc2gSDwoHc3VjY2VzcxgBIAEoCBIPCgdzdW1tYXJ5GAIgASgJIqABCghEZWNpc2lvbhIPCgd0YXNrX2lkGAEgASgJEgwKBHN0ZXAYAiABKA0SEQoJcmF0aW9uYWxlGAMgASgJEhAKCGV2aWRlbmNlGAQgAygJEiMKBmFjdGlvbhgKIAEoCzIRLmZpc3Rvcy52MS5BY3Rpb25IABIjCgZmaW5pc2gYCyABKAsyES5maXN0b3MudjEuRmluaXNoSABCBgoEa2luZCKLAgoIVGFza1N0ZXASDwoHdGFza19pZBgBIAEoCRIMCgRzdGVwGAIgASgNEiEKBmFjdGlvbhgDIAEoCzIRLmZpc3Rvcy52MS5BY3Rpb24SEAoIZXZpZGVuY2UYBCADKAkSEQoJcmF0aW9uYWxlGAUgASgJEioKCGFwcHJvdmFsGAYgASgOMhguZmlzdG9zLnYxLkFwcHJvdmFsQ2xhc3MSLQoIY2F0ZWdvcnkYByABKA4yGy5maXN0b3MudjEuQXBwcm92YWxDYXRlZ29yeRInCgZyZXN1bHQYCCABKAsyFy5maXN0b3MudjEuQWN0aW9uUmVzdWx0EhQKDHRpbWVzdGFtcF9tcxgJIAEoAyJkCgpUYXNrUmVzdWx0Eg8KB3Rhc2tfaWQYASABKAkSJQoGc3RhdHVzGAIgASgOMhUuZmlzdG9zLnYxLlRhc2tTdGF0dXMSDwoHc3VtbWFyeRgDIAEoCRINCgVzdGVwcxgEIAEoDSrkAQoKRGF0YVNvdXJjZRIbChdEQVRBX1NPVVJDRV9VTlNQRUNJRklFRBAAEhcKE0RBVEFfU09VUkNFX1VJX1RSRUUQARIaChZEQVRBX1NPVVJDRV9TQ1JFRU5TSE9UEAISEwoPREFUQV9TT1VSQ0VfU01TEAMSHAoYREFUQV9TT1VSQ0VfTk9USUZJQ0FUSU9OEAQSFAoQREFUQV9TT1VSQ0VfQ0FMTBAFEhwKGERBVEFfU09VUkNFX0NBTExfQ0FQVElPThAGEh0KGURBVEFfU09VUkNFX0FDVElPTl9PVVRQVVQQByrIAQoKVGFza1N0YXR1cxIbChdUQVNLX1NUQVRVU19VTlNQRUNJRklFRBAAEhkKFVRBU0tfU1RBVFVTX1NVQ0NFRURFRBABEhYKElRBU0tfU1RBVFVTX0ZBSUxFRBACEhkKFVRBU0tfU1RBVFVTX0NBTkNFTExFRBADEhkKFVRBU0tfU1RBVFVTX1RJTUVEX09VVBAEEhoKFlRBU0tfU1RBVFVTX1NURVBfTElNSVQQBRIYChRUQVNLX1NUQVRVU19SRUpFQ1RFRBAGYgZwcm90bzM", [file_action, file_approval, file_events, file_observe, file_session]);
/**
 * Describes the message fistos.v1.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema = /*@__PURE__*/ messageDesc(file_task, 0);
/**
 * Describes the message fistos.v1.TaskConstraints.
 * Use `create(TaskConstraintsSchema)` to create a new message.
 */
export const TaskConstraintsSchema = /*@__PURE__*/ messageDesc(file_task, 1);
/**
 * Describes the message fistos.v1.TaskCancel.
 * Use `create(TaskCancelSchema)` to create a new message.
 */
export const TaskCancelSchema = /*@__PURE__*/ messageDesc(file_task, 2);
/**
 * Describes the message fistos.v1.DataBlock.
 * Use `create(DataBlockSchema)` to create a new message.
 */
export const DataBlockSchema = /*@__PURE__*/ messageDesc(file_task, 3);
/**
 * Describes the message fistos.v1.StepSummary.
 * Use `create(StepSummarySchema)` to create a new message.
 */
export const StepSummarySchema = /*@__PURE__*/ messageDesc(file_task, 4);
/**
 * Describes the message fistos.v1.PlanRequest.
 * Use `create(PlanRequestSchema)` to create a new message.
 */
export const PlanRequestSchema = /*@__PURE__*/ messageDesc(file_task, 5);
/**
 * Describes the message fistos.v1.Finish.
 * Use `create(FinishSchema)` to create a new message.
 */
export const FinishSchema = /*@__PURE__*/ messageDesc(file_task, 6);
/**
 * Describes the message fistos.v1.Decision.
 * Use `create(DecisionSchema)` to create a new message.
 */
export const DecisionSchema = /*@__PURE__*/ messageDesc(file_task, 7);
/**
 * Describes the message fistos.v1.TaskStep.
 * Use `create(TaskStepSchema)` to create a new message.
 */
export const TaskStepSchema = /*@__PURE__*/ messageDesc(file_task, 8);
/**
 * Describes the message fistos.v1.TaskResult.
 * Use `create(TaskResultSchema)` to create a new message.
 */
export const TaskResultSchema = /*@__PURE__*/ messageDesc(file_task, 9);
/**
 * Where an untrusted DataBlock came from.
 *
 * @generated from enum fistos.v1.DataSource
 */
export var DataSource;
(function (DataSource) {
    /**
     * @generated from enum value: DATA_SOURCE_UNSPECIFIED = 0;
     */
    DataSource[DataSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DATA_SOURCE_UI_TREE = 1;
     */
    DataSource[DataSource["UI_TREE"] = 1] = "UI_TREE";
    /**
     * @generated from enum value: DATA_SOURCE_SCREENSHOT = 2;
     */
    DataSource[DataSource["SCREENSHOT"] = 2] = "SCREENSHOT";
    /**
     * @generated from enum value: DATA_SOURCE_SMS = 3;
     */
    DataSource[DataSource["SMS"] = 3] = "SMS";
    /**
     * @generated from enum value: DATA_SOURCE_NOTIFICATION = 4;
     */
    DataSource[DataSource["NOTIFICATION"] = 4] = "NOTIFICATION";
    /**
     * @generated from enum value: DATA_SOURCE_CALL = 5;
     */
    DataSource[DataSource["CALL"] = 5] = "CALL";
    /**
     * @generated from enum value: DATA_SOURCE_CALL_CAPTION = 6;
     */
    DataSource[DataSource["CALL_CAPTION"] = 6] = "CALL_CAPTION";
    /**
     * @generated from enum value: DATA_SOURCE_ACTION_OUTPUT = 7;
     */
    DataSource[DataSource["ACTION_OUTPUT"] = 7] = "ACTION_OUTPUT";
})(DataSource || (DataSource = {}));
/**
 * Describes the enum fistos.v1.DataSource.
 */
export const DataSourceSchema = /*@__PURE__*/ enumDesc(file_task, 0);
/**
 * @generated from enum fistos.v1.TaskStatus
 */
export var TaskStatus;
(function (TaskStatus) {
    /**
     * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
     */
    TaskStatus[TaskStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TASK_STATUS_SUCCEEDED = 1;
     */
    TaskStatus[TaskStatus["SUCCEEDED"] = 1] = "SUCCEEDED";
    /**
     * @generated from enum value: TASK_STATUS_FAILED = 2;
     */
    TaskStatus[TaskStatus["FAILED"] = 2] = "FAILED";
    /**
     * @generated from enum value: TASK_STATUS_CANCELLED = 3;
     */
    TaskStatus[TaskStatus["CANCELLED"] = 3] = "CANCELLED";
    /**
     * @generated from enum value: TASK_STATUS_TIMED_OUT = 4;
     */
    TaskStatus[TaskStatus["TIMED_OUT"] = 4] = "TIMED_OUT";
    /**
     * @generated from enum value: TASK_STATUS_STEP_LIMIT = 5;
     */
    TaskStatus[TaskStatus["STEP_LIMIT"] = 5] = "STEP_LIMIT";
    /**
     * @generated from enum value: TASK_STATUS_REJECTED = 6;
     */
    TaskStatus[TaskStatus["REJECTED"] = 6] = "REJECTED";
})(TaskStatus || (TaskStatus = {}));
/**
 * Describes the enum fistos.v1.TaskStatus.
 */
export const TaskStatusSchema = /*@__PURE__*/ enumDesc(file_task, 1);
